export default __webpack_public_path__ + "static/media/Beehaz_09_more_for_less.307f4ba5.png";